import React, {Fragment, useEffect, useState} from 'react'
import {connect} from 'react-redux';
import {getOrders, getOrder} from "./actions";
import _ from 'lodash' ;
import withPaging from '../common/withPaging';
import { useParams } from 'react-router-dom';
import DropDownSearch from '../components/DropDownSearch';
import useInterval from '../components/useInterval';
import ReactTooltip from 'react-tooltip';
import { API_ROUTE } from '../common/apiRoutes';
import toast, { Toaster } from 'react-hot-toast';

const Orders = (props) => {

    const {orders, ordersPaging, pageNumber} = props;
    const [activeEvent, setActiveEvent] = useState();
    const [queryPerson, setQueryPerson] = useState();
    const [queryTransaction, setQueryTransaction] = useState();

    const {eventId} = useParams();

    const getOrders = () => {
        let query = {
            pageNumber,
            pageSize: 10,
            getAll: true,
        };
        if (eventId) {
            query = {...query,
                eventId: Number(eventId)
            }
        }
        if(queryPerson){
            query = {...query,
                customerName: queryPerson,
                pageNumber: 1
            }
            props.setPageNumber(1)
        }
        if(queryTransaction){
            query = {...query,
                orderId: queryTransaction,
                pageNumber: 1
            }
            props.setPageNumber(1)
        }
        props.getOrders(query);
    }

    useEffect(() => {
        ReactTooltip.rebuild();
    }, [orders]);

    useEffect(() => {
        getOrders();
    }, [pageNumber, queryTransaction, queryPerson]);

    useInterval(() => {
        getOrders();
    }, 5000)

    const loadOrderInfo = (orderId) => {
        setActiveEvent(orderId);
        props.getOrder(orderId);
    };

    const activeOrder = props.orderInfos[activeEvent];

    const searchPesron = (query) => {
        setQueryPerson(query);
    }

    const searchTransaction = (query) => {
        setQueryTransaction(query);
    }

    const sendEmail = (eventId) => {
        fetch(`${API_ROUTE}order/SendOrderEmail/${eventId}`).then(d => d.json()).then((data) => {
            toast.success(data.message);
        })
    }

    const sendSms = (eventId) => {
        fetch(`${API_ROUTE}order/SendOrderSms/${eventId}`).then(d => d.json()).then((data) => {
            toast.success(data.message);
        })
    }

    return (
        <Fragment>
            <ReactTooltip />
            <Toaster />

            {!eventId ?
            <div className="maximumSizeHandler">
                <div className="contentTitle" >
                    <span className=" font-size_24 boldFont middleContext">لیست سفارش‌ها</span>
                </div>
                <span className="lineSeparator"></span>
            </div> : null}
            <div className="maximumSizeHandler">
                <div className="tableStructure">
                    <table>
                        <tr className="font-size_16 mediumWFont">
                            <th># <DropDownSearch search={searchTransaction} /></th>
                            {!eventId ? <th data-tip="ارسال فاکتور به ایمیل">نام نمایشگاه</th> : null}
                            <th>نام مشتری <DropDownSearch search={searchPesron} /></th>
                            <th>تاریخ</th>
                            <th>تعداد کتاب</th>
                            <th>مبلغ کل</th>
                            <th>تخفیف</th>
                            <th>مبلغ نهایی</th>
                            <th/>
                        </tr>
                        {!_.isEmpty(ordersPaging) && ordersPaging[pageNumber] ? _.map(ordersPaging[pageNumber], id => {
                            return (
                                <Fragment>
                                    <tr className="font-size_14">
                                        <td onClick={e => loadOrderInfo(id)} className="clickShape">
                                            {orders[id].id}
                                        </td>
                                        {!eventId ? <td>{orders[id].event}</td> : null}
                                        <td onClick={e => loadOrderInfo(id)} className="clickShape">{orders[id].fullName}</td>
                                        <td>{`${orders[id].jalaliDate} ${orders[id].jalaliTime}`}</td>
                                        <td>{orders[id].ordersCount}</td>
                                        <td>{orders[id].originalPrice.toLocaleString()}</td>
                                        <td>{orders[id].discountAmount}</td>
                                        <td>{orders[id].amount.toLocaleString()}</td>
                                        <td>
                                            <div className='printersWrapper'>
                                                <a href={`http://factor.paratechco.com/factor/${orders[id].id}`} data-tip="چاپ فاکتور" target="_blank" rel="noopener noreferrer">
                                                    <span className="icon icon-printer"></span>
                                                </a>
                                                <a href={`http://factor.paratechco.com/smallfactor/${orders[id].id}`} data-tip="چاپ رسید" target="_blank" rel="noopener noreferrer">
                                                    <span className="icon icon-receipt"></span>
                                                </a>
                                                <span onClick={e => {e.preventDefault();sendEmail(orders[id].id)}} data-tip="ارسال فاکتور به ایمیل" target="_blank" rel="noopener noreferrer">
                                                    <span className="icon icon-envelop"></span>
                                                </span>
                                                <span onClick={e => {e.preventDefault();sendSms(orders[id].id)}} data-tip="ارسال فاکتور به همراه" target="_blank" rel="noopener noreferrer">
                                                    <span className="icon icon-mobile"></span>
                                                </span>
                                            </div>
                                        </td>

                                    </tr>
                                    {activeOrder && activeOrder.id == id  ?
                                        <Fragment>
                                            <tr className="grayBack relativeMove">
                                                <th></th>
                                                <th>عنوان کتاب</th>
                                                <th>مبلغ واحد</th>
                                                <th>تعداد</th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                            </tr>
                                            {_.map(activeOrder.items, i => (
                                                <tr className="grayBack relativeMove">
                                                    <td>
                                                        <img src={i.book.thumbnail} />
                                                    </td>
                                                    <td>{i.book.name}</td>
                                                    <td>{i.book.price}</td>
                                                    <td>{i.count}</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            ))}

                                        </Fragment>
                                        : null}
                                    {/*<td className="blueColor">مشاهده نتایج <span className="icon icon-left font-size_12"></span></td>*/}
                                </Fragment>
                            )
                        }) : null}

                    </table>
                </div>
                {!_.isEmpty(orders) ? props.paginationRender(pageNumber,  Math.ceil(orders[ordersPaging[1][0]]?.totalCount || 0 / 10)) : null}
            </div>
        </Fragment>
    );
};

const mapStateToProps = ({orders, ordersPaging, orderInfos}) => ({
    orders,
    ordersPaging,
    orderInfos
});

export default connect(mapStateToProps, {getOrders, getOrder})(withPaging(Orders));
